if (!customElements.get('aura-product-finder')) {
  const counts = new Map();
  const getCount = (action, query) => {
    const url = new URL(action, window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('section_id', 'aura-finder-availability');
    const key = url.href;
    if (!counts.has(key)) {
      counts.set(key, fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) }).then(async response => {
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const raw = html.querySelector('[data-aura-result-count]')?.dataset.auraResultCount;
        if (raw == null || !/^\d+$/.test(raw)) throw new Error('Missing search count');
        return Number(raw);
      }).catch(error => { counts.delete(key); throw error; }));
    }
    return counts.get(key);
  };
  customElements.define('aura-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('form');
      const kind = this.querySelector('[data-kind]');
      const themes = [...this.querySelectorAll('[data-theme]')];
      const picker = this.querySelector('[data-theme-picker]');
      const summary = this.querySelector('[data-theme-summary]');
      const allLabel = summary.textContent;
      const previous = this.dataset.searchTerms || '';
      if (previous.includes('title:moeda*') && !previous.includes('-product_type:')) {
        const corrected = new URL(window.location.href);
        corrected.searchParams.set('q', previous.replace('title:moeda*', '(title:moeda* AND -product_type:"Estojo para moedas")'));
        corrected.searchParams.delete('page');
        window.location.replace(corrected.href);
        return;
      }
      const found = [...kind.options].find(option => option.value && previous.includes(option.value));
      if (found) kind.value = found.value;
      themes.forEach(input => { input.checked = previous.includes(input.value); });
      const updateSummary = () => {
        const selected = themes.filter(input => input.checked);
        summary.textContent = selected.length ? selected.map(input => input.nextElementSibling.textContent).join(' + ') : allLabel;
      };
      themes.forEach(input => input.addEventListener('change', updateSummary));
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape') { picker.open = false; summary.focus(); }
      });
      let revision = 0;
      let pending;
      const syncThemes = async () => {
        const current = ++revision;
        const selectedKind = kind.value;
        picker.setAttribute('aria-busy', 'true');
        themes.forEach(input => { input.disabled = true; });
        try {
          const matches = await Promise.all(themes.map(async input => {
            try {
              return await getCount(form.action, [selectedKind, input.value].filter(Boolean).join(' AND ')) > 0;
            } catch { return true; }
          }));
          if (current !== revision) return;
          themes.forEach((input, index) => {
            input.closest('label').hidden = !matches[index];
            input.disabled = !matches[index];
            if (!matches[index]) input.checked = false;
          });
          updateSummary();
        } finally {
          if (current === revision) picker.removeAttribute('aria-busy');
        }
      };
      kind.addEventListener('change', () => { pending = syncThemes(); });
      updateSummary();
      pending = syncThemes();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        let waiting;
        do { waiting = pending; await waiting; } while (waiting !== pending);
        const selected = themes.filter(input => input.checked && !input.disabled).map(input => input.value);
        const themeQuery = selected.length ? '(' + selected.join(' OR ') + ')' : '';
        const terms = [kind.value, themeQuery].filter(Boolean);
        if (!terms.length) { window.location.assign(form.querySelector('.aura-finder__catalog').href); return; }
        const url = new URL(form.action, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', terms.join(' AND '));
        window.location.assign(url.href);
      });
    }
  });
}
